import { render, staticRenderFns } from "./form-student.vue?vue&type=template&id=71fa889c&"
import script from "./form-student.vue?vue&type=script&lang=js&"
export * from "./form-student.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports